import { SegmentedControl } from '@mantine/core';
import { useLocation, useNavigate } from 'react-router';
import { useAuth } from '../lib/hooks.ts';

// Переключатель разделов «Склад | Экономика» (просьба 26.09.2026: визуально не пересекаются).
// Экономика — только для администратора; последняя открытая страница каждого раздела запоминается.
const LAST = { wms: 'mode.last.wms', eco: 'mode.last.eco' };
const get = (k: string, d: string) => { try { return localStorage.getItem(k) || d; } catch { return d; } };

export function ModeSwitch() {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  if (user?.role !== 'admin') return null;
  const eco = location.pathname.startsWith('/eco');
  return (
    <SegmentedControl
      size="xs" radius="xl" className="mode-switch" data-eco={eco || undefined}
      value={eco ? 'eco' : 'wms'}
      data={[{ value: 'wms', label: 'Склад' }, { value: 'eco', label: 'Экономика' }]}
      onChange={(v) => {
        try { localStorage.setItem(eco ? LAST.eco : LAST.wms, location.pathname + location.search); } catch { /* приватный режим */ }
        navigate(v === 'eco' ? get(LAST.eco, '/eco') : get(LAST.wms, '/today'));
      }}
    />
  );
}
